import { SyntheticEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import Tab from "@mui/material/Tab";

import { InfoIcon, TaskGropsIcon } from "@dotnet/telematics-design-system";

import SegmentedToggle, {
    TAB_SIZES
} from "components/DesignComponents/SegmentedToggle";
import { useMediaQueries } from "shared";

import DeviceGroupTasks from "./DeviceGroupTasks";
import Header from "./Header";
import SmartGroupFiles from "./SmartGroupFiles";

const DeviceGroupDetails = () => {
    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_: SyntheticEvent, newValue: number) =>
        setTabValue(newValue);

    return (
        <>
            <Header />

            <div>
                <SegmentedToggle
                    value={tabValue}
                    size={TAB_SIZES.Small}
                    tabWidth={toMd ? "258px" : "377px"}
                    onChange={handleTabChange}
                >
                    <Tab
                        label={t("Table details##smart group files")}
                        icon={<InfoIcon />}
                    />

                    <Tab
                        label={t("Table details##device group tasks")}
                        icon={<TaskGropsIcon />}
                    />
                </SegmentedToggle>
            </div>

            {tabValue === 0 && <SmartGroupFiles />}
            {tabValue === 1 && <DeviceGroupTasks />}
        </>
    );
};

export default DeviceGroupDetails;
